import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function paisComboReducer(state= initialState.paisCombo, action){
	switch(action.type){
		case types.GET_PAISS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}